import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Chart, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';

import { buildChartJsOptionsProp } from './options'
import { buildChartjsPluginsProp } from './plugins'

import { getChartHeight } from '@utils/heights'

export const HeatmapChart = ({ datasets, options, className, height }) => {
  const chartRef = useRef(null);
  const canvasRef = useRef(null);

  Chart.register(CategoryScale, LinearScale, MatrixController, MatrixElement, Tooltip, Legend);

  useEffect(() => {
    const ctx = canvasRef.current.getContext('2d');

    if (chartRef.current) {
      chartRef.current.destroy()
    }

    chartRef.current = new Chart(ctx, {
      type: 'matrix',
      data: { datasets: datasets },
      options: buildChartJsOptionsProp(options),
      plugins: buildChartjsPluginsProp()
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy()
      }
    };
  }, [datasets, options]);

  return (
    <div className={className} style={{ height: getChartHeight(height) }}>
      <canvas ref={canvasRef} />
    </div>
  );
};

HeatmapChart.propTypes = {
  dataset: PropTypes.array.isRequired,  // 2D array of values
  options: PropTypes.object,
  height: PropTypes.string,
  className: PropTypes.string
}

HeatmapChart.defaultProps = {
  options: {},
  height: '',
  className: ''
}
